import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { string, arrayOf, shape, object } from "prop-types";

import { HeaderMenuItem, NavSubMenu } from "../../atoms";

import "./MenuWithDropdown.m.css";

const MenuWithDropdown = ({ subMenuitems, customStyleName, menuItemvalue, href, config, story }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const pageType = get(qtState, ["pageType"], null);
  const navSubMenu = (
    <NavSubMenu
      subMenuitems={subMenuitems}
      customStyleName="absolute-position"
      parentMenuName={menuItemvalue}
      story={story}
      config={config}
      pageType={pageType}
    />
  );

  if (!subMenuitems?.length) return null;
  return (
    <ul className="menu-with-dropdown" styleName={`menu-with-dropdown ${customStyleName}`}>
      <HeaderMenuItem menuItemvalue={menuItemvalue} href={href} pageType={pageType} config={config} story={story}>
        {navSubMenu}
      </HeaderMenuItem>
    </ul>
  );
};

MenuWithDropdown.defaultProps = {
  subMenuitems: [],
  customStyleName: "",
  menuItemvalue: "Rankings",
  href: "",
  config: {},
  story: {},
};

MenuWithDropdown.propTypes = {
  subMenuitems: arrayOf(
    shape({
      menuItemLink: string,
      menuItemName: string,
    })
  ).isRequired,
  customStyleName: string,
  menuItemvalue: string,
  href: string,
  config: object,
  story: object,
};

export default MenuWithDropdown;
